import(/* webpackMode: "eager", webpackExports: ["GenericEntityPageClient"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/components/classrooms/generic-entity-page-client.tsx");
